export default process.env.NODE_ENV === "development"
  ? "/api"
  : process.env.REACT_APP_URL;
